import { createContext, useContext } from 'react';

const ExperienceContext = createContext({ isPhone: false });

export function Provider({ isPhone, children }) {
  return (
    <ExperienceContext.Provider value={{ isPhone }}>
      {children}
    </ExperienceContext.Provider>
  );
}

export function useExperience() {
  return useContext(ExperienceContext);
}
